import useMode from '../stores/mode';
import useMarker from '../stores/marker';
import markers from '../data/markers';

import Back from './Back';

function Index() {
    const mode = useMode();
    const marker = useMarker();

    return (
        <section className="Index">
            <h2 className="Index-title">Index</h2>

            {markers?.length && (
                <section className="Index-posts">
                    {markers.map((_marker, index) => (
                        <article
                            className={`Index-post Index-post--${_marker?.type}`}
                            key={_marker.barcodeValue}
                            onClick={() => {
                                console.log('Index.onCLick()', _marker);

                                if (_marker.type === 'link' && _marker.link.url) {
                                    window.location.href = _marker.link.url;
                                } else {
                                    mode.set('item');
                                    marker.setId(_marker.barcodeValue);
                                }
                            }}
                        >
                            <h2 className="Index-post-title">{_marker?.title}</h2>
                        </article>
                    ))}
                </section>
            )}

            <Back></Back>
        </section>
    );
}

export default Index;
